import * as Sentry from '@sentry/react';

import { env } from './env';

export function initSentry(): void {
  if (!env.sentryDsn) return;

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.sentryEnv,
    // Atribuye cada error a un deploy concreto. Se OMITE cuando la version se
    // desconoce: un release inventado simula trazabilidad y estorba justo en
    // medio de un incidente. Ver env.ts.
    ...(env.appVersion ? { release: env.appVersion } : {}),
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}
